export const EMPTY = '—';
export const EMAIL_ADDRESS_MAX_LENGTH = 255;
export const DATA_TEST_ID_PROP = 'data-test-id';
